import { render, staticRenderFns } from "./BudgetLimitsExpenses.vue?vue&type=template&id=7a2844d5&scoped=true&"
import script from "./BudgetLimitsExpenses.vue?vue&type=script&lang=js&"
export * from "./BudgetLimitsExpenses.vue?vue&type=script&lang=js&"
import style0 from "./BudgetLimitsExpenses.vue?vue&type=style&index=0&id=7a2844d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2844d5",
  null
  
)

export default component.exports